import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
const AddMP = ({ show, onClose, refresh }) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const [name, setname] = useState('');
    const [amountPPack, setAmount] = useState('');
    // const [staff, setstaff] = useState(null);
    const [agrementSdate, setAgStartDate] = useState(null);
    const [agrementEdate, setAgEndDate] = useState(null);
    const [Advanceamount, setAdvanceAmount] = useState('');
    const [advanceDate, setAdvancedate] = useState(null);
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [existing, setExisting] = useState([]);
    const [mobile_no, setMobileno] = useState('');
    const [vehicle_no, setVehiNo] = useState('');
    const [license_no, setLiceNo] = useState('');
    const [cost, setCose] = useState(null);
    const [type, setType] = useState(null);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // const [staffoption, setstaffopt] = useState([]);
    // useEffect (() => {
    //     axios.get(`${baseURL}/dropdown/get_staffs`, {params: {branch_id: branch_id}})
    //     .then(response => {
    //         const formattedsource = response.data.data.map(item => ({
    //             value: item.sno,
    //             label: item.employee_name,
    //         }));
    //         setstaffopt(formattedsource);
    //     })
    //     .catch(error => {
    //         console.log(error);
    //     });
    // }, []);

    useEffect(() => {
        axios.get(`${baseURL}/meals_point`)
            .then(response => {
                setExisting(response.data.data.map(mode => mode.name.toLowerCase()));
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
            });
    }, []);


    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const handleAgSDate = (dateValue) => {
        // Format the selected date to 'YYYY-MM-DD' and store it in the state
        if (dateValue) {
          const formattedDate = dateValue.format('YYYY-MM-DD');
          setAgStartDate(formattedDate);
        } else {
          setAgStartDate(null);
        }
    };

    const handleAgEDate = (dateValue) => {
        // Format the selected date to 'YYYY-MM-DD' and store it in the state
        if (dateValue) {
          const formattedDate = dateValue.format('YYYY-MM-DD');
          setAgEndDate(formattedDate);
        } else {
          setAgEndDate(null);
        }
    };

    const handleAdDate = (dateValue) => {
        // Format the selected date to 'YYYY-MM-DD' and store it in the state
        if (dateValue) {
          const formattedDate = dateValue.format('YYYY-MM-DD');
          setAdvancedate(formattedDate);
        } else {
          setAdvancedate(null);
        }
    };


    const validate = () => {
        const newErrors = {};

        if (type === null) {
            newErrors.typ = "This Field is Required.";
        }

        if (!name) {
            newErrors.name = "This Field is Required.";
        }

        if (!mobile_no) {
            newErrors.mob = "This Field is Required.";
        }

        if (type === 0) {
            if (!amountPPack) {
                newErrors.amountppack = "This Field is Required.";
            }

            if(!agrementSdate){
                newErrors.agreementsdate = "This Field is Required.";
            }

            if(!agrementEdate){
                newErrors.agreementsenddate = "This Field is Required.";
            }
        }

        if (type === 1) {
            if (!vehicle_no) {
                newErrors.vno = "This Field is Required.";
            }

            if(!license_no){
                newErrors.lno = "This Field is Required.";
            }

            if(!cost){
                newErrors.cst = "This Field is Required.";
            }
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = { 
            branch_id: branch_id,
            meals_point_type: type,
            name: name,
            mobile_no: mobile_no,
            pack_amount: amountPPack,
            // staff_id: staff,
            agreement_start_date: agrementSdate,
            agreement_end_date: agrementEdate,
            advance_amount: Advanceamount,
            advance_date: advanceDate,
            vehicle_number: vehicle_no,
            license_number: license_no,
            cost_per_km: parseFloat(cost) || 0,
            description: description.trim() || "",
            created_by: user_id,
        };
        
        // Send the request to the backend
        axios.post(`${baseURL}/meals_point`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Meals Point Created Successfully!");
            })
            .catch(error => {
                console.error("Error:", error);
                toast.error("Meals Point Creation Failed");
            });
    };

    const mp_type = [
        { value: 0, label: "Agency" },
        { value: 1, label: "Freelancer" }
    ];


    return (
        <Modal show={show} size="lg">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Meals Point</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Type <span className="required">*</span></label>
                            <Select
                                options={mp_type}
                                placeholder="Select Type"
                                onChange={(e) => { setType(e.value); }}
                            />
                            {errors.typ && <small className="text-danger">{errors.typ}</small>}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Name<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Name"
                                maxLength={200}
                                value={name}
                                onChange={(e) => {
                                    const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    setname(formatName(onlyAlphabets));
                                }}
                            />
                            {errors && <small className="text-danger">{errors.name}</small>}
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Mobile No<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Mobile No" 
                                maxLength={10}
                                value={mobile_no} 
                                onChange={(e) => {
                                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                    setMobileno(onlyNums);
                                }}
                            />
                            {errors.mob && <div className="text-danger fs-8 mt-1">{errors.mob}</div>}
                        </div>
                        
                        {type === 0 && (
                            <>
                                <div className="col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3">
                                    <label className="text-black font-w500 fs-7">Amount Per Pack<span className="required">*</span></label>
                                    <input type="text" className="form-control" placeholder="Enter Amount"
                                        maxLength={10}
                                        value={amountPPack}
                                        onChange={(e) => {
                                            const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                            setAmount(onlyNumbers);
                                        }}
                                    />
                                    {errors.amountppack && <small className="text-danger">{errors.amountppack}</small>}
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-black font-w500 fs-7'>Agreement Start Date<span className="required">*</span></label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker placeholder='Select Date'
                                            format="DD-MM-YYYY"
                                            onChange={handleAgSDate}
                                        />
                                    </div>
                                    {errors.agreementsdate && <small className="text-danger">{errors.agreementsdate}</small>}
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-black font-w500 fs-7'>Agreement End Date<span className="required">*</span></label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker placeholder='Select Date'
                                            format="DD-MM-YYYY"
                                            onChange={handleAgEDate}
                                        />
                                    </div>
                                    {errors.agreementsenddate && <small className="text-danger">{errors.agreementsenddate}</small>}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3">
                                    <label className="text-black font-w500 fs-7">Advance</label>
                                    <input type="text" className="form-control" placeholder="Enter Amount"
                                        maxLength={10}
                                        value={Advanceamount}
                                        onChange={(e) => {
                                            const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                            setAdvanceAmount(onlyNumbers);
                                        }}
                                    />
                                    {errors.advanceamount && <small className="text-danger">{errors.advanceamount}</small>}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3">
                                    <label className='text-black font-w500 fs-7'>Advance Date</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker placeholder='Select Date'
                                            format="DD-MM-YYYY"
                                            onChange={handleAdDate}
                                        />
                                    </div>
                                    {errors.advanceDate && <small className="text-danger">{errors.advanceDate}</small>}
                                </div>
                            </>
                        )}

                        {type === 1 && (
                            <>
                               <div className="col-lg-6 mb-3">
                                    <label className="text-black font-w500 fs-7">Vehicle Number<span className="required">*</span></label>
                                    <input type="text" className="form-control" placeholder="Enter Vehicle number" 
                                        maxLength={25}
                                        value={vehicle_no}
                                        onChange={(e) => setVehiNo(e.target.value)}
                                    />
                                    {errors.vno && <div className="text-danger fs-8 mt-1">{errors.vno}</div>}
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label className="text-black font-w500 fs-7">License Number<span className="required">*</span></label>
                                    <input type="text" className="form-control" placeholder="Enter License Number" 
                                        maxLength={30}
                                        value={license_no}
                                        onChange={(e) => setLiceNo(e.target.value)}
                                    />
                                    {errors.lno && <div className="text-danger fs-8 mt-1">{errors.lno}</div>}
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label className="text-black font-w500 fs-7">Cost Per Km<span className="required">*</span></label>
                                    <input type="text" className="form-control" placeholder="Enter Cost Per Km" 
                                        maxLength={10}
                                        value={cost} 
                                        onChange={(e) => {
                                            const onlyNums = e.target.value.replace(/[^0-9.]/g, '');
                                            setCose(onlyNums);
                                        }}
                                    />
                                    {errors.cst && <div className="text-danger fs-8 mt-1">{errors.cst}</div>}
                                </div>
                            </>
                        )}

                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Enter Description" value={description}
                            onChange={(e) => setDescription(e.target.value)} />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <button type="submit" className="btn btn-sm btn-primary">Create Meals Point<i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                </form>
                </div>
            </div>
        </Modal>
    );
};

export default AddMP;
